import { render, staticRenderFns } from "./DetailSPTPage.vue?vue&type=template&id=d882c7b8&scoped=true&"
import script from "./DetailSPTPage.vue?vue&type=script&lang=js&"
export * from "./DetailSPTPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailSPTPage.vue?vue&type=style&index=0&id=d882c7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882c7b8",
  null
  
)

export default component.exports